import { Link } from "react-router-dom";

function Title() {
  return (
    <div className="title">
      <Link to="/polygone">mehdibouzoubaa</Link>
    </div>
  );
}

export default Title;
